import React, { useEffect, useState } from "react";
import { logo } from "assets/assets";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { loginUser } from "../../Slices/authSlice";

const ROLE_OPTIONS = [
    { value: "superAdmin", label: "Super Admin" },
    { value: "subAdmin", label: "Sub Admin" },
    { value: "editor", label: "Editor" },
    { value: "districtManager", label: "District Manager" },
];

const SigninForm = ({ role: initialRole }) => {
    const [loginId, setLoginId] = useState("");
    const [password, setPassword] = useState("");
    const [selectedRole, setSelectedRole] = useState(initialRole || "superAdmin");
    const [authError, setAuthError] = useState(null);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { loading, error, user } = useSelector((state) => state.auth);

    useEffect(() => {
        if (initialRole && initialRole !== selectedRole) {
            setSelectedRole(initialRole);
        }
        // run only when initialRole changes to avoid overwriting user selection
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialRole]);

    useEffect(() => {
        // Clear any stale errors when switching roles for a cleaner UX
        setAuthError(null);
    }, [selectedRole]);

    useEffect(() => {
        if (user) {
            if (user.isSuperAdmin || user.role === "superAdmin") {
                navigate("/dashboard", { replace: true });
            } else {
                navigate("/cms", { replace: true });
            }
        }
    }, [user, navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setAuthError(null);

        if (!selectedRole) {
            setAuthError("Please choose a role to continue.");
            return;
        }

        try {
            const actionResult = await dispatch(
                loginUser({ id: loginId.trim(), password, role: selectedRole })
            );

            if (loginUser.rejected.match(actionResult)) {
                setAuthError(actionResult.payload || "Login failed. Please try again.");
            }
        } catch (err) {
            const message =
                err?.data?.message ||
                err?.response?.data?.message ||
                err?.message ||
                "Login failed. Please try again.";
            setAuthError(message);
        }
    };

    return (
        <div className="signinPage">
            <div className="bgArt" />
            <div id="signinForm">
                <div className="headContent">
                    <div className="imgWrapper">
                        <img src={logo} alt="trektourtravel.com logo" />
                    </div>
                    <h2>Welcome back</h2>
                    <p>Glad to see you again 👋</p>
                </div>

                <form onSubmit={handleSubmit}>
                    <div>
                        <label htmlFor="role">Role</label>
                        <select
                            id="role"
                            value={selectedRole}
                            onChange={(e) => setSelectedRole(e.target.value)}
                            required
                        >
                            {ROLE_OPTIONS.map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div>
                        <label htmlFor="email">Login ID</label>
                        <input
                            value={loginId}
                            onChange={(e) => setLoginId(e.target.value)}
                            required
                            type="text"
                            id="email"
                            placeholder="Enter login ID..."
                        />
                    </div>
                    <div>
                        <label htmlFor="password">Password</label>
                        <input
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            type="password"
                            id="password"
                            placeholder="Enter password..."
                        />
                    </div>
                    <button type="submit" disabled={loading} className="btn-blue w-100">
                        {loading ? "Signing in..." : "Sign in"}
                    </button>
                    {(authError || error) && (
                        <p style={{ textAlign: "center", color: "red" }}>❌ {authError || error}</p>
                    )}
                </form>
            </div>
        </div>
    );
};

export { SigninForm };
